import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface ISlotsIconProps extends ISvgIconProps {

}

export class SlotsIcon extends React.Component<ISlotsIconProps> {
    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 19 18" fill={'none'}>
                <g clipPath="url(#clip0_11018_281865)">
                    <g clipPath="url(#clip1_11018_281865)">
                        <path d="M9.95044 1.80273C9.95044 1.80273 10.4562 2.38686 11.5371 2.77138" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M3.8894 10.5215C3.8894 10.5215 4.65088 10.8698 5.88812 10.7619" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12.0969 11.1521C12.0969 11.1521 12.9326 11.1 13.973 10.4229" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M4.80127 10.7179C4.80127 10.7179 5.2611 6.55981 10.7453 2.40723" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M13.1475 10.852C13.1475 10.852 9.7834 7.19598 10.8802 2.48438" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M4.88841 16.207C6.93089 16.207 8.58664 14.5535 8.58664 12.5137C8.58664 10.4739 6.93089 8.82031 4.88841 8.82031C2.84594 8.82031 1.19019 10.4739 1.19019 12.5137C1.19019 14.5535 2.84594 16.207 4.88841 16.207Z" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M13.6919 16.0449C15.7344 16.0449 17.3901 14.3913 17.3901 12.3516C17.3901 10.3118 15.7344 8.6582 13.6919 8.6582C11.6494 8.6582 9.99365 10.3118 9.99365 12.3516C9.99365 14.3913 11.6494 16.0449 13.6919 16.0449Z" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_11018_281865">
                        <rect width="18" height="18" fill="currentColor" transform="translate(0.290039)"/>
                    </clipPath>
                    <clipPath id="clip1_11018_281865">
                        <rect width="18" height="18" fill="currentColor" transform="translate(0.290039)"/>
                    </clipPath>
                </defs>
            </SvgIcon>
        );
    }
}
